import React from "react";
import refundHeroBox from "../../assets/images/refund/refund-hero-box.png";
import { resolvePublicFileUrl } from "../../constants/api-urls";

/** Hero illustration — CMS upload when provided, otherwise default mockup graphic. */
export default function RefundHeroVisual({ imageUrl = "" }) {
  const customSrc = imageUrl ? resolvePublicFileUrl(imageUrl) : "";
  const src = customSrc || refundHeroBox;

  return (
    <div className="hub-refund-hero__visual" aria-hidden>
      <img
        src={src}
        alt=""
        className={`hub-refund-hero__visual-img${customSrc ? " hub-refund-hero__visual-img--custom" : ""}`}
        width={520}
        height={280}
        decoding="async"
      />
    </div>
  );
}
